import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthStateService, PlatformService } from '@sml/utility';

@Component({
  selector: 'app-auth-login',
  template: '',
  standalone: true,
  imports: [CommonModule],
})
export class AuthLoginComponent {
  private readonly authState = inject(AuthStateService);
  private readonly platformService = inject(PlatformService);

  constructor() {
    if(this.platformService.browser()){
      this.onLoginClick();
    }
  }

  onLoginClick(): void {
    this.authState.auth.loginWithRedirect({
      authorizationParams:{
        screen_hint: 'login',
      },
      appState: { target: '/callback' }
    });
  }

}
